import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { UserContext } from "../../providers/user-provider";
import { connect } from 'react-redux';
import { compose } from 'redux';
import { dateToTimestamp } from '../../firebase';
import * as Actions from '../../redux/actions/';
import DatePicker from '../date-picker/';
import InputField from '../input-field';
import Editor from '../editor/';
import debounce from 'lodash.debounce';
import './add-review.scss';

const AddReview = ({ albumData, addNotification, impersonationUser, onChange, reviewData}) => {
	const userContext = useContext(UserContext);
	const user = impersonationUser || userContext;
	const reviewId = reviewData.id || user.id;

	const handleScoreChange = (evt) => {
		const val = evt && evt.target && evt.target.value;
		if (val >=0 && val <= 10) {
			onChange({score: parseFloat(val) * 10}, reviewId);
		}
	};

	const handleSummaryChange = (evt) => {
		const val = evt && evt.target && evt.target.value;
		onChange({summary: val}, reviewId);
	};
	const handleReviewDateChange = (val) => {
		if (val !== null) {
			let changeObj;
			if (albumData.isLegacy) {
				changeObj = {
					legacyDate: val,
					reviewDate: dateToTimestamp(new Date())
				}
			} else {
				changeObj = {reviewDate: val}
			}
			onChange(changeObj, reviewId);
		}
	};

	function handleEditorChange (content) {
		onChange({content: content}, reviewId);
	}

	function reviewDataLocked () {
		return typeof reviewData.id === 'string' && reviewData.id !== user.id && userContext.role !== 'owner';
	}

	function getReviewDate () {
		const reviewDateStamp = albumData.isLegacy ? reviewData.legacyDate : reviewData.reviewDate;
		return reviewDateStamp || dateToTimestamp(new Date());
	}

	return (
		<div className="review-editor">
			<div className=" col-layout layout-30-70">
				<div className="sidebar">
					<InputField
						id="reviewAlbum"
						label="Album"
						value={albumData.artist && albumData.album ? `${albumData.artist} - ${albumData.album}` : ''}
						disabled
					/>
					<InputField
						id="reviewAuthor"
						label="Author"
						value={(reviewData.author) || user.name}
						disabled
					/>
					<DatePicker
						disabled={userContext.role !== 'owner'}
						id="reviewDate"
						label="Review Date"
						onChange={handleReviewDateChange}
						value={getReviewDate()}
					/>
					<InputField
						disabled={reviewDataLocked()}
						id="summary"
						label="Summary"
						onChange={handleSummaryChange}
						placeholder="Sum things up in 150 characters or less. This will display at the bottom of your review next to your score and maybe on twitter/facebook some day."
						type="textarea"
						maxLength="150"
						value={reviewData.summary || ''}
					/>
					<InputField
						id="score"
						label="Score"
						type="number"
						value={(reviewData.score && reviewData.score/10) || 0}
						step="0.1"
						min="0"
						max="10"
						onChange={handleScoreChange}
						disabled={reviewDataLocked()}
					/>
				</div>
				<div className="editor-wrap">
					<div className="form-element">
						<h2>Review Content</h2>
						<Editor
							context="add-review"
							data={reviewData.content || ''}
							onInit={() => {
							}}
							onChange={debounce(content => { handleEditorChange(content); }, 600)}
							disabled={reviewDataLocked()}
						/>
					</div>
				</div>
			</div>
		</div>
	)
};

AddReview.defaultProps = {
	reviewData: {},
	albumData: {}
}

AddReview.propTypes = {
	albumData: PropTypes.object,
	reviewData: PropTypes.object
}

const mapStateToProps = state => {
	return {
		impersonationUser: state.impersonationUser
	}
}

const mapDispatchToProps  = {
	addNotification: Actions.addNotification
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps)
)(AddReview)
